<button [type]="type" class="btn"
        id={{inId}}
        [attr.data-cy]="inDataCy || inId || btnLabel.toLowerCase()"
        [class.btn-default]="btnTypeDefault"
        [class.btn-primary]="btnTypePrimary"
        [class.btn-danger]="btnTypeDanger"
        [class.btn-block]="btnStretch"
        [class.btn-top-space]="spaceTop"
        [class.btn-bottom-space]="spaceBottom"
        [class.btn-top-space-large]="spaceTopLarge"
        [class.btn-top-space-none]="spaceNone"
        [class.btn-success]="iconSave"
        [ngClass]="customClass"
        title="{{ title }}"
        [disabled]="disabled">
  <span class="glyphicon glyphicon-ok" aria-hidden="true" *ngIf="iconCheckMark"></span>
  <span class="glyphicon glyphicon-plus" aria-hidden="true" *ngIf="iconAdd"></span>
  <span class="glyphicon glyphicon-minus" aria-hidden="true" *ngIf="iconMinus"></span>
  <span class="glyphicon glyphicon-remove" aria-hidden="true" *ngIf="iconRemove"></span>
  <span class="glyphicon glyphicon-arrow-left" aria-hidden="true" *ngIf="iconPrevious"></span>
  <span class="glyphicon glyphicon-floppy-disk" aria-hidden="true" *ngIf="iconSave"></span>
  <span class="glyphicon glyphicon-pencil" aria-hidden="true" *ngIf="iconPencil"></span>
  <span class="glyphicon glyphicon-step-forward" aria-hidden="true" *ngIf="iconForward"></span>
  <span class="glyphicon glyphicon-resize-full" aria-hidden="true" *ngIf="iconExpandAll"></span>
  <span class="glyphicon glyphicon-resize-small" aria-hidden="true" *ngIf="iconCollapseAll"></span>
  <span class="glyphicon glyphicon-plus" aria-hidden="true" *ngIf="iconPlus"></span>
  {{btnLabel}}
  <span class="glyphicon glyphicon-arrow-right" aria-hidden="true" *ngIf="iconNext"></span>
  <span class="glyphicon glyphicon-step-backward" aria-hidden="true" *ngIf="iconBackward"></span>
</button>
